export default __webpack_public_path__ + "static/media/upgrade-report12.498393a5.png";